import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class WashRequest {
    static data(props) {
        App.log('WASH_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0].requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('WASH_REQUEST.DELETE', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            statusId: 21
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }
}

class SectionWashRequest extends WashRequest {
    static insert(props) {
        App.log('SECTION_WASH_REQUEST.INSERT', App.LOG.FETCH, props);

        const body = {
            patientFileCodeId: props.patientFileCodeId,
            patientDiagnosticId: props.patientDiagnosticId,
            patientDiagnosticStr: props.patientDiagnosticStr,
            requestReasonStr: props.requestReasonStr,
            docterId: props.docterId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.WASH.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static list() {
        App.log('SECTION_WASH_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.WASH.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static update(props) {
        App.log('SECTION_WASH_REQUEST.UPDATE', App.LOG.FETCH, props);

        const body = {
            sectionWashedRequestId: props.sectionWashedRequestId,
            patientFileCodeId: props.patientFileCodeId,
            patientDiagnosticId: props.patientDiagnosticId,
            patientDiagnosticStr: props.patientDiagnosticStr,
            requestReasonStr: props.requestReasonStr,
            docterId: props.docterId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.WASH.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }
}

class HospitalWashRequest extends WashRequest {
    static addProduct(props) {
        App.log('HOSPITAL.ADD_PRODUCT_TO_WASH_REQUEST', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            crossMatchIdList: props.crossMatchIdList
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.WASH.ADD_PRODUCT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    // static insert (props) {
    //     App.log('HOSPITAL_WASH_REQUEST.INSERT', App.LOG.FETCH, props);
    //
    //     const body = {
    //         patientFileCodeId: props.patientFileCodeId,
    //         patientDiagnosticId: props.patientDiagnosticId,
    //         patientDiagnosticStr: props.patientDiagnosticStr,
    //         requestReasonStr: props.requestReasonStr,
    //         docterNameStr: props.docterNameStr
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.HOSPITAL_WASH_REQUEST.INSERT, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve(result.objList[0]);
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.INSERT_FAILED);
    //         });
    //     });
    // }

    // static update (props) {
    //     App.log('HOSPITAL_WASH_REQUEST.UPDATE', App.LOG.FETCH, props);
    //
    //     const body = {
    //         sectionWashedRequestId: props.sectionWashedRequestId,
    //         patientFileCodeId: props.patientFileCodeId,
    //         patientDiagnosticId: props.patientDiagnosticId,
    //         patientDiagnosticStr: props.patientDiagnosticStr,
    //         requestReasonStr: props.requestReasonStr,
    //         docterNameStr: props.docterNameStr
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.HOSPITAL_WASH_REQUEST.UPDATE, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve();
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.INSERT_FAILED);
    //         });
    //     });
    // }

    static list() {
        App.log('HOSPITAL_WASH_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.WASH.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static removeProduct(props) {
        App.log('HOSPITAL.REMOVE_PRODUCT_FROM_WASH_REQUEST', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            crossMatchIdList: [props.crossMatchId]
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.WASH.REMOVE_PRODUCT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }

    static sendRequestToOrg(props) {
        App.log('HOSPITAL.SEND_REQUEST_TO_ORG', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.SEND_TO_ORG, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject('ارسال درخواست به سازمان با خطا روبرو شد.');
            });
        });
    }
}

class OrganizationWashRequest extends WashRequest {
    static data(props) {
        App.log('ORGANIZATION_WASH_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        console.log(result);
                        resolve({...result.objList[0].hospitalWashedRequestFormVM, ...result.objList[0].requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static list() {
        App.log('ORGANIZATION_WASH_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.WASH.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export {SectionWashRequest, HospitalWashRequest, OrganizationWashRequest};